import $ from '../core/Dom';

/**
 * Prompt marquee.
 *
 * Cross-fades through the example instructions in the AI Image Editor mock,
 * ported from that site's hero.
 *
 * The first prompt carries `is-active` in the markup, so the field still
 * shows something if the JS never boots — and under a reduced-motion
 * preference that's simply where it stays.
 */
export default (el, props = {}) => {
    const $el = $(el);
    const interval = (props || {}).interval || 2600;

    let items = [];
    let index = 0;
    let timer = null;

    const show = next => {
        index = ((next % items.length) + items.length) % items.length;

        items.forEach((item, i) => {
            $(item).toggleClass('is-active', i === index);
        });
    };

    const stop = () => {
        if (timer) {
            clearInterval(timer);
            timer = null;
        }
    };

    const start = () => {
        stop();

        // Nothing to cycle through
        if (items.length < 2) {
            return;
        }

        // Auto-cycling text is motion — leave it on the first prompt instead
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            return;
        }

        timer = setInterval(() => {
            show(index + 1);
        }, interval);
    };

    const init = () => {
        items = $el.find('[data-prompt]').get();

        if (!items.length) {
            return;
        }

        show(0);
        start();
    };

    const destroy = () => {
        stop();
        items = [];
    };

    return {
        init,
        destroy
    };
};
